module.exports = __webpack_public_path__ + "static/media/Logo_spstudio.3bc3c351.png";